import { DataLoadingStatus } from '../../types';
import { io, Socket } from 'socket.io-client';
import { Component } from 'preact';

interface Props {
  dataLoadingStatus: DataLoadingStatus;
  organizationId: string;
  requestStatus: string;
  requestId: number;
  onStatusChanged: () => void;
}

interface SocketData {
  data: {
    request: {
      status: number;
      id: number;
    };
  };
}

class SocketHandler extends Component<Props> {
  socket: Socket<any, any> | null = null;

  componentDidMount() {
    const { organizationId } = this.props;

    this.socket = organizationId
      ? io(process.env.APP_SOCKET_URL, { path: `/socket.io/${organizationId}`, closeOnBeforeunload: false })
      : io(process.env.APP_SOCKET_URL, { path: '/socket.io', closeOnBeforeunload: false });

    this.socket.on('connect', () => {
      console.log(`assist socket connected for requestId ${this.props.requestId}`);
    });

    this.socket.on('disconnect', () => {
      console.log(`assist socket disconnected for requestId ${this.props.requestId}`);
    });

    this.socket.on('requests_delete', ({ data }: SocketData) => {
      if (data.request.id === this.props.requestId) {
        this.props.onStatusChanged();
      }
    });

    this.socket.on('requests_update', ({ data }: SocketData) => {
      if (
        data.request.id === this.props.requestId &&
        this.props.dataLoadingStatus !== DataLoadingStatus.Loading &&
        this.props.dataLoadingStatus !== DataLoadingStatus.Failure
      ) {
        this.props.onStatusChanged();
      }
    });
  }

  componentWillUnmount() {
    try {
      this.socket.disconnect();
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return null;
  }
}

export default SocketHandler;
